// ForgotPasswordPage.jsx
import React, { useState,useEffect } from "react";
import { forgotPassword } from "./authService";

const ForgotPasswordPage = () => {
  useEffect(() => {
    document.title = "Forgot Password | Workgear365";
  }, []);
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setSuccess("");

    try {
      const res = await forgotPassword({ email });
      setSuccess(res.data.message || "Password reset link sent to your email.");
      setEmail("");
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(Object.values(err.response.data.errors).flat());
      } else {
        setErrors(["Unable to send reset link."]);
      }
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="card shadow">
            <div className="card-header bg-primary text-white">
              <h4 className="mb-0">Forgot Password</h4>
            </div>
            <div className="card-body p-4">
              {errors.map((e, i) => (
                <div key={i} className="alert alert-danger py-1">{e}</div>
              ))}
              {success && <div className="alert alert-success">{success}</div>}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-bold">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Send Reset Link
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
